export default {
  namespaced: true,
  state: {
    voiceCallState: 'idle',
    caller: '',
    sid: '',
    customer: null,
    conversation: null,
    startTimer: false,
    metadata: {
      inbound: true,
    },
  },
  mutations: {
    UPDATE_CALLER(state, caller) {
      state.caller = caller;
    },
    UPDATE_CALL_STATE(state, callState) {
      state.voiceCallState = callState;
    },
    UPDATE_CALL_SID(state, sid) {
      state.sid = sid;
    },
    UPDATE_CUSTOMER(state, customer) {
      state.customer = customer;
    },
    UPDATE_CONVERSATION(state, conversation) {
      state.conversation = conversation;
    },
    UPDATE_TIMER_STATE(state, timer) {
      state.startTimer = timer;
    },
    UPDATE_METADATA(state, metadata) {
      state.metadata = metadata;
    },

  },
  actions: {
    updateCaller({ commit }, caller) {
      commit('UPDATE_CALLER', caller);
    },
    updateCallState({ commit }, callState) {
      commit('UPDATE_CALL_STATE', callState);
    },
    updateCallSid({ commit }, sid) {
      commit('UPDATE_CALL_SID', sid);
    },
    updateCustomer({ commit }, customer) {
      commit('UPDATE_CUSTOMER', customer);
    },
    updateConversation({ commit }, conversation) {
      commit('UPDATE_CONVERSATION', conversation);
    },
    updateTimerState({ commit }, data) {
      commit('UPDATE_TIMER_STATE', data);
    },
    updateMetadata({ commit }, metadata) {
      commit('UPDATE_METADATA', metadata);
    },
  },
};